// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M = M || {};
M.Date = M.Date || {};

M.Date.WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday',
    'Friday', 'Saturday'];
M.Date.MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];

/**
 * Returns a human-readable string representation of the date.
 *
 * e.g. Tuesday, December 2
 */
M.Date.toDisplayString = function(date) {
  // TODO: If/when we need other formats, use a date formatting
  // library like moment.js.
  if (typeof moment !== 'undefined') {
    return moment(date).format('dddd, MMMM DD');
  } else {
    var day = date.getDay();
    var weekdayString = M.Date.WEEKDAYS[day];
    var month = date.getMonth();
    var monthString = M.Date.MONTHS[month];
    if (weekdayString && monthString) {
      return weekdayString + ', ' + monthString + ' ' + date.getDate();
    }
  }
};

M.Date.toStringDayMonth = function(date){
  var month = date.getMonth();
  var monthString = M.Date.MONTHS[month];
  if (monthString) {
    return monthString + ' ' + date.getDate();
  }
};

/**
 * Returns a datetime object for Midnight today.
 *
 * @return {Date}
 */
M.Date.midnight = function() {
  var midnight = new Date();
  midnight.setHours(0);
  midnight.setMinutes(0);
  midnight.setSeconds(0);
  midnight.setMilliseconds(0);
  return midnight;
};

/**
 * Generates a unix timestamp
 *
 * We strip off the miliseconds on the timestamp
 * to make it a proper unix timestamp.
 *
 * Arguments
 * date {Date} (optional) the Date object to generate a timestamp from
 *   if no date is given, a new date will be constructed.
 *
 * Returns
 * a unix timestamp representation of the given date
 */
M.Date.generateUnixTimestamp = function(date) {
  // if the argument is not given, then use a default value
  date = date || new Date();
  var timestamp = date.getTime();
  timestamp = parseInt(timestamp / 1000, 10);
  return timestamp;
};

/**
 * Return the UTC version of a javascript Date object.
 *
 * @param {Date} date - local (browser) date time
 * @return {Date} dateUTC - UTC date time
 */
M.Date.getUTC = function(date) {
  // Adds the user's time zone offset
  var browserOffset = date.getTimezoneOffset() * 60 * 1000;
  var dateUTC = new Date(date.getTime() + browserOffset);
  return dateUTC;
};
